import { NsProgress } from 'components/common/ns-progress/NsProgress';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsContent } from 'components/common/ns-content/NsContent';

export const energyNeedsHeaderTestId = 'energyNeedsHeaderTestId';

export const EnergyNeedsHeader = () => {
  return (
    <NsContent data-testid={energyNeedsHeaderTestId}>
      <NsBackCta />
      <NsProgress />
      <h1>What are your energy needs?</h1>
      <h5>Let&apos;s find you the right tariff</h5>
    </NsContent>
  );
};

export default EnergyNeedsHeader;
